import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IFeesFormMeta {
    identifier: FormInputMeta;
    name: FormInputMeta;
    feeType: FormInputMeta;
    type: FormInputMeta;
    amount: FormInputMeta;
    //
    schema: any;
  }

const FeesFormMeta = {} as IFeesFormMeta;

FeesFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.feeType = {
  name: "feeType",
  label: "Type frais",
  type: "select",
  options:  [
      {
        label: 'Type frais A',
        value: 'a'
      },
      {
        label: 'Type frais B',
        value: 'b'
      },
      {
        label: 'Type frais C',
        value: 'b'
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.type = {
  name: "type",
  label: "Type",
  type: "select",
  options:  [
      {
        label: 'Montant',
        value: 'a'
      },
      {
        label: 'Unit',
        value: 'b'
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.amount = {
  name: 'amount',
  type: 'text',
  label: 'Montant',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};


FeesFormMeta.schema = yup.object().shape(getValidationSchema(FeesFormMeta));

export default FeesFormMeta;